import { Config } from "@config";
import type { ReactNode } from "react";
import React from "react";

interface AbTestProps {
	version: "A" | "B";
	children: ReactNode;
}

export const AbTest: React.FC<AbTestProps> = ({ version, children }: AbTestProps) => {
	if (Config.getAbVersion() === version) {
		return <>{children}</>;
	}

	return null;
};
